import * as R from 'ramda';
// constants
import * as GC from '../constants';
// helpers
import {
  isObject,
  isString,
  isNilOrEmpty,
  isNotNilAndNotEmpty,
} from './helpers';
import { getPropFromObject } from './getter';
import { createStringFromArray } from './string';
//////////////////////////////////////////////////

const isItemTypeVehicle = (item) => {
  if (isNilOrEmpty(item)) return false;

  if (isString(item)) return R.equals(GC.ITEM_TYPE_VEHICLE, item);

  if (isObject(item)) return R.equals(GC.ITEM_TYPE_VEHICLE, getPropFromObject(GC.FIELD_ITEM_TYPE, item));

  return false;
};

const createSequenceApproxValue = (sequence) => {
  if (isNilOrEmpty(sequence)) return '';

  const { prefix, suffix, approxValue, approximateSequenceValue } = sequence;

  if (isNotNilAndNotEmpty(approximateSequenceValue)) return approximateSequenceValue;

  const arrayOfValues = [prefix, approxValue, suffix];

  return createStringFromArray(arrayOfValues, '');
};

const isChatMessageAuthorTypeCarrier = (authorType) =>
  R.equals(authorType, 'CARRIER');

const isChatMessageAuthorTypeDriver = (authorType) =>
  R.equals(authorType, 'DRIVER');

const isChatMessageAuthorTypeCarrierOrDriver = (authorType = '') =>
  R.or(isChatMessageAuthorTypeCarrier(authorType), isChatMessageAuthorTypeDriver(authorType));

export {
  isItemTypeVehicle,
  createSequenceApproxValue,
  isChatMessageAuthorTypeDriver,
  isChatMessageAuthorTypeCarrier,
  isChatMessageAuthorTypeCarrierOrDriver,
};
